/**
 * The initials function takes a string input (presumably a name or any phrase) and returns the initials derived from it.
 * The function is designed to handle different cases: single words, multiple words, and empty strings
 * @param str string to pull initials from
 * @returns uppercase string initials
 */
export const initials = (str: string): string => {
  const words = str.split(" ");
  if (words.length === 0) {
    return "";
  }
  if (words.length === 1) {
    return words[0][0] || "";
  }
  return words[0][0] + words[1][0];
};

export const titleCaseString = (input: string) => {
  if (!input) {
    return "";
  }
  return input
    .replace(/([^A-Z])([A-Z])/g, "$1 $2") // split cameCase
    .replace(/[_\-]+/g, " ") // split snake_case and lisp-case
    .toLowerCase()
    .replace(/(^\w|\b\w)/g, function (m) {
      return m.toUpperCase();
    }) // title case words
    .replace(/\s+/g, " ") // collapse repeated whitespace
    .replace(/^\s+|\s+$/, ""); // remove leading/trailing whitespace
};

export const downCaseString = (input: string) => {
  if (!input) {
    return "";
  }
  return input
    .replace(/([^A-Z])([A-Z])/g, "$1 $2") // split camelCase
    .replace(/[_\-]+/g, " ") // split snake_case and lisp-case
    .toLowerCase()
    .replace(/\s+/g, " ") // collapse repeated whitespace
    .replace(/^\s+|\s+$/, ""); // remove leading/trailing whitespace
};

export const firstName = (input: string): string => {
  if (!input || typeof input !== "string") return "";

  return input.split(" ")[0];
};

export const lastName = (input: string): string => {
  if (!input || typeof input !== "string") return "";

  const names = input.split(" ");
  names.shift(); // drop the first name
  return names.join(" "); // join the rest
};

export const capitalizeFirst = (str: string): string => {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1);
};
